import { createContext, useContext } from "react";
import mainStore from "./mainStore";

import roleStore from "./roleStore";
import userStore from "./userStore";

import panelStore from "./panelStore";
import categoryStore from "./categoryStore";
import subcategoryStore from "./subcategoryStore";
import typeOfToolStore from "./typeOfToolStore";
import toolPassportStore from "./toolPassportStore";
import criteriaStore from "./criteriaStore";
import criteriaValueStore from "./criteriaValueStore";
import toolFeatureStore from "./toolFeatureStore";

// Content Management stores
import ResearchPublicationStore from "./researchPublicationStore";
import ResearchTeamMemberStore from "./researchTeamMemberStore";
import PlatformHistoryStore from "./platformHistoryStore";
import SystemVersionStore from "./systemVersionStore";
import KeyFeatureStore from "./keyFeatureStore";
import MCDMMethodStore from "./mcdmMethodStore";

export const store = {
  mainStore: new mainStore(),
  userStore: new userStore(),
  roleStore: new roleStore(),

  panelStore: new panelStore(),
  categoryStore: new categoryStore(),
  subcategoryStore: new subcategoryStore(),
  typeOfToolStore: new typeOfToolStore(),
  toolPassportStore: new toolPassportStore(),

  criteriaStore: new criteriaStore(),
  criteriaValueStore: new criteriaValueStore(),
  toolFeatureStore: new toolFeatureStore(),

  // Content Management stores
  researchPublicationStore: new ResearchPublicationStore(),
  researchTeamMemberStore: new ResearchTeamMemberStore(),
  platformHistoryStore: new PlatformHistoryStore(),
  systemVersionStore: new SystemVersionStore(),
  keyFeatureStore: new KeyFeatureStore(),
  mcdmMethodStore: new MCDMMethodStore(),

};

export const StoreContext = createContext(store);

export function useStore() {
  return useContext(StoreContext);
}
